
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lmniterbzhfihvxsumbl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxtbml0ZXJiemhmaWh2eHN1bWJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ3NjYxNTYsImV4cCI6MjA2MDM0MjE1Nn0.s--WjDJb84QOQBWMpA77aGOKNPYK2uW9TyNjOndJ_ag";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
